<!--
Notification

Will poll graphQL endpoint for any new updates, and present the text as a notification component
-->

<template>
	<section
		aria-label="Notification"
		aria-live="assertive"
		class="c-notification"
		v-bind:class="colorClass"
		v-if="isVisible"
	>
		<!--you must allow this notice to be dismissed by screenreaders
    as it interrupts the announcer -->
		<div class="c-notification__container">
			<div class="c-notification__text" v-html="this.content"></div>
			<button
				class="c-notification__action js-notification-trigger"
				v-on:click="close"
			>
				<span class="h-accessibility">Close this notice.</span>
				<span class="icon i-close i-close--small" aria-hidden="true">
					<crossIcon />
				</span>
			</button>
		</div>
	</section>
</template>

<script>
	import crossIcon from "/web/static/images/svgs/base-cross.svg?component";

	export default {
		name: "v-notification",
		data: function () {
			return {
				isVisible: false,
				heading: null,
				content: null,
				colour: null,
				updatedAt: null,
				interval: null,
			};
		},
		components: {
			crossIcon,
		},
		props: {
			siteHandle: {
				type: String,
			},
		},
		computed: {
			colorClass() {
				if (this.colour == "red") {
					return "c-notification--error";
				} else if (this.colour == "green") {
					return "c-notification--success";
				} else {
					return "";
				}
			},
		},
		mounted() {
			this.getNotification();

			this.interval = setInterval(
				function () {
					this.getNotification();
				}.bind(this),
				30000,
			);
		},
		beforeUnmount() {
			clearInterval(this.interval);
		},
		methods: {
			getNotification: function () {
				// get notifications via graphql endpoint
				fetch("/notifications-endpoint", {
					method: "POST",
					headers: {
						"content-type": "application/json",
					},
					body: JSON.stringify({
						query: `
            {
              globalSet(site: "${this.siteHandle}", handle: ["notifications"]) {
                ... on notifications_GlobalSet {
                  siteNotification {
                    ...on siteNotification_BlockType {
                      notification
                      enableNotification
                      start
                      end
                      dateUpdated
                    }
                  }
                }
              }
            }`,
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						let responseData = data.data.globalSet.siteNotification;
						let currentDate = Math.round(+new Date() / 1000);
						let activeNotification;

						for (let i = 0; i < responseData.length; i++) {
							if (responseData[i].enableNotification) {
								let startDateTimestamp = Math.floor(
									new Date(responseData[i].start).getTime() / 1000,
								);
								let endDateTimestamp = Math.floor(
									new Date(responseData[i].end).getTime() / 1000,
								);

								if (
									!(startDateTimestamp && currentDate < startDateTimestamp) &&
									!(endDateTimestamp && currentDate > endDateTimestamp)
								) {
									activeNotification = responseData[i];
									break;
								}
							}
						}

						if (activeNotification && activeNotification.notification) {
							let updatedAtTimestamp = Math.floor(
								new Date(activeNotification.dateUpdated).getTime() / 1000,
							);

							this.content = activeNotification.notification;
							this.updatedAt = updatedAtTimestamp;

							this.showNotification();
						} else {
							this.isVisible = false;
						}
					})
					.catch((error) => {
						console.log(error);
					});
			},
			removePageStyle: function () {
				document.querySelector("#app").style.paddingTop = "0px";
			},
			setVisited: function () {
				localStorage.setItem("sc-site-notification:closed", this.updatedAt);
			},
			getVisited: function () {
				return parseInt(localStorage.getItem("sc-site-notification:closed"));
			},
			removeVisited: function () {
				localStorage.removeItem("sc-site-notification:closed");
			},
			showNotification: function () {
				if (!this.getVisited()) {
					this.isVisible = true;
				} else if (this.getVisited() !== this.updatedAt) {
					this.removeVisited();
					this.isVisible = true;
				}
			},
			close: function () {
				this.setVisited();
				this.removePageStyle();

				this.isVisible = false;
			},
		},
	};
</script>
